import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import Wakeup from "../../assets/images/wakeup.png"

const Wakeup_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={Wakeup} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-widtli>h">
        <h2 className="spec-title">{t('accessoires.wakeup.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.wakeup.details.p1')}</li>
          <li>{t('accessoires.wakeup.details.p2')}</li>
          <li>{t('accessoires.wakeup.details.p3')}</li>
          <li>{t('accessoires.wakeup.details.p4')}</li>
          <li>{t('accessoires.wakeup.details.p5')}</li>
        </ul>
      </div>

    </div>
  );
};

export default Wakeup_SPEC;
